<form class="app-form" [formRoot]="form">
  <div class="setup-content" id="step-4">
    <h4>{{ 'PASSWORD_RESET.TITLE' | translate }}</h4>
    <p>{{ 'PASSWORD_RESET.SUBTITLE' | translate }}</p>
    <div class="form-group">
      <label class="col-form-label">{{ 'PASSWORD_RESET.PASSWORD' | translate }}</label>
      <div class="relative" data-field-wrapper>
        <input
          class="form-control pr-16"
          [formField]="form.password"
          autocomplete="current-password"
          placeholder="Enter password"
          [type]="revealPassword() ? 'text' : 'password'"
          appFormFieldOnError
        />
        <app-password-visibility-toggle [revealed]="revealPassword()" (toggled)="togglePasswordVisibility()" />
      </div>
    </div>
    <div class="form-group">
      <label class="col-form-label">{{ 'PASSWORD_RESET.CONFIRM_PASSWORD' | translate }}</label>
      <input
        class="form-control"
        [formField]="form.confirmPassword"
        placeholder="Enter password"
        autocomplete="current-password"
        type="password"
        appFormFieldOnError
      />
    </div>
    <div class="form-group mb-0">
      <button
        class="btn btn-gradient float-right mt-4"
        type="submit"
        [disabled]="form().invalid() || form().submitting()"
      >
        {{ 'PASSWORD_RESET.RESET' | translate }}
      </button>
      <button class="btn btn-outline-secondary float-right mr-4 mt-4" type="button">
        {{ 'PASSWORD_RESET.BACK_TO_LOGIN' | translate }}
      </button>
    </div>
  </div>
</form>
